import { createFileRoute } from '@tanstack/react-router';
import EmailSettings from '@Views/Settings/email-settings';

export const Route = createFileRoute('/settings/_layout/emails')({
    component: EmailSettings,
});
